module.exports = __webpack_public_path__ + "static/media/close2.250e8526.svg";